import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import 'reset.css'
import { isLiebao, compareLiebaoVersion } from '@/utils'
import { clientGetLiebaoVersion } from '@/client'
import { rightDisplay } from '@/views/rights'

Vue.config.productionTip = false
// 如果不是猎豹浏览器，或者小于某个版本,展示下载猎豹浏览器页面
// 展示页面为手动挂载， 指定版本配置在 .env文件里面
if (!isLiebao ||
  compareLiebaoVersion(clientGetLiebaoVersion(), process.env.VUE_APP_SUPPORT_LIEBAO_VERSION) < 0) {
  rightDisplay()
} else {
  // 挂载 vue 渲染节点
  const domMount = function () {
    // eslint-disable-next-line no-new
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  // 同步获取浏览器用户数据
  store.commit('getUserInfo')
  // 如果用户在浏览器端已经登录。执行PDF自动登录
  // 在PDF后台中， 猎豹用户作为第三方用户登录，
  // 登录流程 浏览器客户端登录 -> PDF 服务器端登录 -> 登录完成执行渲染流程
  if (store.getters.isLogin) {
    store.dispatch('officeLogin').finally(() => {
      domMount()
    })
  } else {
    domMount()
  }
}
